import openModalAction from 'modules/modal/redux/actions/open'
import { MODAL_ID } from 'modules/modal/redux/constants'

/**
 * @param props
 * @param props.variantId
 * @param props.top
 * @return {(function(*): void)|*}
 */
export default function openRecurrenceSidebarSubscriptionAction (props) {
  return dispatch => {
    const {
      variantId,
      top
    } = props
    dispatch(
      openModalAction(MODAL_ID.SUBSCRIPTION_RECURRENCE, {
        variantId,
        top
      })
    )
  }
}
